import React, { useState } from "react";
import { BsHeart } from "react-icons/bs";
// import { FaHeart } from 'react-icons/fa';
import { IoBagOutline } from "react-icons/io5";
import { MdOutlineFileDownload } from "react-icons/md";
export const Right = ({data}) => {
  const [selectedLicense, setSelectedLicense] = useState("personal");

  const handleSelection = (license) => {
    setSelectedLicense(license);
  };
  return (
    <div className="bg-[#F0F0F0] dark:bg-[#282828] mt-4 h-full p-4 rounded-2xl lg:w-[500px]">
      <div className="flex flex-col md:flex-row md:space-x-2 justify-between">
        <p className="text-2xl">Quick Actions</p>
        <div className="flex space-x-2 pt-4 md:pt-0">
          <div className="border-[1.5px]  border-[#1C1C1C] dark:border-gray-500 rounded-lg w-fit px-2 flex items-center space-x-1">
            <MdOutlineFileDownload className="text-xl" />
            <p>Free Sample</p>
          </div>
          <div className="border border-[#D3D3D3] dark:border-gray-500 w-fit p-2 rounded-md">
            <BsHeart />
          </div>
        </div>
      </div>
      <div className="pt-6">
        <h1 className="text-2xl py-2 ">Pricing options</h1>
        <div className="space-y-2">
          <div
            className={`flex border items-center justify-between px-4 py-[10px] rounded-xl cursor-pointer ${
              selectedLicense === "personal"
                ? "border-[#1c1c1c] bg-gray-100 dark:bg-transparent dark:border-white"
                : "border-[#D3D3D3] dark:border-[#5b5b5b]"
            }`}
            onClick={() => handleSelection("personal")}
          >
            <div className="flex items-center space-x-4">
              <div
                className={`w-3 h-3 rounded-full border ${
                  selectedLicense === "personal"
                    ? "border-[#1c1c1c] dark:border-white flex items-center justify-center"
                    : "border-[#1c1c1c] dark:border-white"
                }`}
              >
                {selectedLicense === "personal" && (
                  <div className="w-1.5 h-1.5 rounded-full bg-[#1c1c1c] dark:bg-white" />
                )}
              </div>
              <p>Personal License</p>
            </div>
            <p>$47</p>
          </div>

          <div
            className={`flex border items-center justify-between px-4 py-[10px] rounded-xl cursor-pointer ${
              selectedLicense === "commercial"
                ? "border-[#1c1c1c] bg-gray-100 dark:bg-transparent dark:border-white "
                : "border-[#D3D3D3] dark:border-[#5B5B5B]"
            }`}
            onClick={() => handleSelection("commercial")}
          >
            <div className="flex items-center space-x-4">
              <div
                className={`w-3 h-3 rounded-full border ${
                  selectedLicense === "commercial"
                    ? "border-[#1c1c1c] flex items-center justify-center dark:border-white"
                    : "border-[#1c1c1c] dark:border-white"
                }`}
              >
                {selectedLicense === "commercial" && (
                  <div className="w-1.5 h-1.5 rounded-full bg-[#1c1c1c] dark:bg-white dark:bg-transparent" />
                )}
              </div>
              <p>Commercial License</p>
            </div>
            <p>{data.card.price}</p>
          </div>
        </div>
      
        <div className="flex mt-3 justify-center items-center space-x-2 bg-[#1C1C1C] text-white dark:bg-white dark:text-black rounded-xl  py-[14px] px-4">
          <IoBagOutline />
          <p>Add to Cart</p>
        </div>
      </div>
      <div className="pt-6">
        <h1 className="pb-4 text-2xl">Need Customization?</h1>
        <button className="bg-orange-400 text-black w-full py-3 px-5 rounded-lg">
          Get in Touch With Us
        </button>
      </div>

      <div className="border px-4 mt-6 py-2 border-[#D3D3D3] dark:border-gray-500 rounded-lg">
        <p className="text-2xl">
          License:{" "}
          <span className="text-black dark:text-white">Commercial</span>
        </p>
        <p className="pt-3">
          Not sure what that means? <span className="">Read details</span>
        </p>
      </div>

      <div className="py-4">
        <h1 className="py-2 text-2xl">Useful Info</h1>
        <div className="  flex-col gap-4 border border-[#D3D3D3]  dark:border-gray-500 rounded-lg p-2  leading-10 px-4">
          <div className="flex items-center justify-between">
            <p>Last Updates:</p>
            <p>Feb 24th, 2023</p>
          </div>
          <div className="flex items-center justify-between">
            <p>Release Date:</p>
            <p>Apr 5th, 2022</p>
          </div>
          <div className="flex items-center justify-between">
            <p>Format:</p>
            <p>.FIG, Vector</p>
          </div>
          <div className="flex items-center justify-between">
            <p>Instructions:</p>
            <p>Yes</p>
          </div>
          <div className="flex items-center justify-between">
            <p>Size:</p>
            <p>17 Mb</p>
          </div>
          <div className="flex items-center justify-between">
            <p>Constant Updates:</p>
            <p>Yes</p>
          </div>
        </div>
      </div>

      <div>
        <h1 className="py-2 text-2xl">Design by</h1>
        <div className="flex border-[#D3D3D3] dark:border-gray-500 items-center space-x-4 border px-4 py-2 rounded-lg">
          <img
            className="w-10 h-10 rounded-full object-cover"
            src={data.card.user.picture}
            alt=""
          />
          <div>
            <h5 className="text-lg">{data.card.user.name}</h5>
            <p>Sr. Staff UX Designer - Premium UI Kits</p>
          </div>
        </div>
      </div>
    </div>
  );
};
